import { render, staticRenderFns } from "./locale-select.vue?vue&type=template&id=0fba3fcd&scoped=true&"
import script from "./locale-select.vue?vue&type=script&lang=js&"
export * from "./locale-select.vue?vue&type=script&lang=js&"
import style0 from "./locale-select.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./locale-select.vue?vue&type=style&index=1&id=0fba3fcd&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0fba3fcd",
  null
  
)

export default component.exports